import { formatDate } from '@angular/common';

import { MessageModel } from '../types';

export const messageGroupData = (messages: MessageModel[], currentLang: string): Record<string, string> => {
  const groupData: Record<string, string> = {};
  const currentYear = new Date().getFullYear();

  messages.forEach(message => {
    let messageGroupDate: string | null;
    const messageDate = message.dateCreated;
    const dateFormat = messageDate.getFullYear() === currentYear ? 'd MMMM' : 'd MMMM y';

    messageGroupDate = formatDate(messageDate, dateFormat, currentLang);

    if (messageGroupDate && !Object.values(groupData).find(groupDate => groupDate === messageGroupDate)) {
      groupData[message.id] = messageGroupDate;
    }
  });

  return groupData;
};
